/*=========================================================================================
  File Name: moduleOpportuniteGetters.js
  Description: Opportunite Module Getters
  ----------------------------------------------------------------------------------------
==========================================================================================*/


export default {

}